import { Dispatch } from "@reduxjs/toolkit";
import { addSnackbar } from "../../redux/snackbars/snackbars.slice";

export class ErrorHandler {
    constructor(private dispatch: Dispatch) {}

    handle(error: Error | unknown, customMessage?: string): void {
        const message = customMessage || (error instanceof Error ? error.message : "An unknown error occurred");

        console.error("[ErrorHandler]", error);

        this.dispatch(
            addSnackbar({
                color: "error",
                title: message,
            })
        );
    }
}

export const createErrorHandler = (dispatch: Dispatch) => new ErrorHandler(dispatch);
